import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr'; // Import ToastrModule if you plan to use ToastrService
import { ParckingComponent } from './parcking.component';
import { DiverManagementComponent } from '../diver-management/diver-management.component';
import { DiverManagementModule } from '../diver-management/diver-management.module';

@NgModule({
  declarations: [
    ParckingComponent,
  ],
  imports: [
    CommonModule, // Import CommonModule for Angular common directives
    ToastrModule.forRoot(),
    DiverManagementModule
  ],
  exports: [
    ParckingComponent // Export the component if it needs to be used in other modules
  ]
})
export class ParkingModule { }
